/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Belief_Title_2Inputs */

const en_about_belief_title_2 = /** @type {(inputs: About_Belief_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you can point to.`)
};

const lv_about_belief_title_2 = /** @type {(inputs: About_Belief_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kas redzams darbā.`)
};

/**
* | output |
* | --- |
* | "you can point to." |
*
* @param {About_Belief_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_belief_title_2 = /** @type {((inputs?: About_Belief_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Belief_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_belief_title_2(inputs)
	return en_about_belief_title_2(inputs)
});